import { Alert, AlertIcon, Button, Flex, Text } from '@chakra-ui/react';
import { useState } from 'react';
import CheckoutModal from 'src/components/molecules/checkout-modal';
import { gaEvent } from 'src/utils/gtag';

interface OrderSummaryProps {
  message: string;
  btnMessage: string;
  alertMessage?: string;
  fetchClientSecret: () => Promise<string>;
  gaValue?: string | number;
  gaSkip?: boolean;
}

export const PaymentAlert = ({
  message,
  btnMessage,
  alertMessage,
  fetchClientSecret,
  gaValue,
  gaSkip,
}: OrderSummaryProps) => {
  const [showModal, setShowModal] = useState<boolean>(false);
  const [sessionKey, setSessionKey] = useState(0);

  const handleClose = () => {
    setShowModal(false);
    setSessionKey(sessionKey + 1);
  };

  return (
    <Flex mb={{ base: 2, md: 4, lg: 6 }} justify="center" direction="column">
      <Alert status="warning">
        <AlertIcon />
        <Flex direction={{ base: 'column', md: 'row' }} align="center" width="100%">
          <Text mb={{ base: 2, md: 0 }}>{message}</Text>
          <Button
            colorScheme="primary"
            size="sm"
            ml={{ base: 0, md: 4 }}
            width={{ base: 'full', md: 'auto' }}
            onClick={() => {
              if (btnMessage === 'Pay to List' && !gaSkip) {
                gaEvent({
                  action: 'payment_cta_click',
                  category: 'engagement',
                  label: 'pay_to_list',
                  value: gaValue,
                });
              }
              setShowModal(true);
            }}
          >
            {btnMessage}
          </Button>
        </Flex>
      </Alert>
      <Text fontSize="xs" color="gray.600" mt={2} ml={4}>
        {alertMessage}
      </Text>
      <CheckoutModal
        key={sessionKey}
        isOpen={showModal}
        onClose={handleClose}
        fetchClientSecret={fetchClientSecret}
      />
    </Flex>
  );
};
